export default "__VITE_ASSET__BufIWuDc__"